import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Timezone-safe date-only handling. A pure "YYYY-MM-DD" string parses as UTC
// midnight in JS: it renders a day EARLY in negative-offset zones (US) and, for
// comparisons, a day LATE in far-positive zones (Guam UTC+10). Route ALL
// date-only values through these helpers. Full ISO timestamps (with a time
// component) parse normally and are unaffected.
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function parseDateOnly(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return isNaN(value) ? null : value;
  const s = String(value).trim();
  if (DATE_ONLY_RE.test(s)) {
    const [y, m, d] = s.split("-").map(Number);
    const dt = new Date(y, m - 1, d); // construct in LOCAL time -> no TZ shift
    return isNaN(dt) ? null : dt;
  }
  const dt = new Date(s); // full ISO timestamp -> normal parse
  return isNaN(dt) ? null : dt;
}

export function formatDateOnly(value, opts) {
  const dt = parseDateOnly(value);
  if (!dt) return "—";
  return dt.toLocaleDateString(undefined, opts);
}
